
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-15 -10 30 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#DA251d","d":"M-20-15h40v30h-40z"}}),_c('g',{attrs:{"id":"b","transform":"translate(0 -6)"}},[_c('path',{attrs:{"id":"a","fill":"#FF0","transform":"rotate(18)","d":"M0 0v6h4"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('g',{attrs:{"id":"c","transform":"rotate(72)"}},[_c('use',{attrs:{"xlink:href":"#b"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"scale(-1 1)"}})])
          )
        }
      }
    